<template>
  <div>
    <BaseButton primary small @click="createProductReaction"> Create Product Reaction </BaseButton>
  </div>
</template>

<script>
// import { throttle } from 'lodash-es';
import { accountAccProductsClient, contactAccProductReactionsClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
    accProductReactionTypeOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      accProducts: [],
    };
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId] || null;
    },
    accProductOptions() {
      return this.accProducts.map((accProduct) => ({
        label: accProduct.name,
        value: accProduct.id,
      }));
    },
  },
  methods: {
    createProductReaction() {
      const vm = this;
      this.$modal.show({
        component: () => import('Components/AccProductReactions/AccProductReactionCreateModal.vue'),
        props: {
          action: this.storeAccProductReaction,
          accProductOptions: vm.accProductOptions,
          accProductReactionTypeOptions: this.accProductReactionTypeOptions,
          searchAccProducts: (search) => vm.fetchAccProducts({ filter: { search } }),
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async storeAccProductReaction(data) {
      try {
        await contactAccProductReactionsClient.store(this.contactId, mapKeysToSnakeCase(data));

        this.$emit('create');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchAccProducts(query = {}) {
      try {
        const response = await accountAccProductsClient.list(this.contact.accountId, query);

        const accProducts = response.data.map(mapKeysToCamelCase);

        return Promise.resolve(accProducts);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
